module.exports = __webpack_public_path__ + "d4fbdf40b7b80ce65122eb6e3c9b7c4f.svg";